import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import {
  GiftsListViewComponent, GiftsListItemComponent, GiftsListComponent,
  GiftCardComponent, GiftDetailsComponent, GiftRedeemComponent
} from '@app/gifts';


@NgModule({
  declarations: [
    GiftsListItemComponent,
    GiftsListComponent,
    GiftCardComponent,
    GiftDetailsComponent,
    GiftRedeemComponent,
    GiftsListViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    GiftsListItemComponent,
    GiftsListComponent
  ]
})
export class GiftsModule { }
